import {
  FETCH_PROMOS,
  FETCH_PROMOS_SUCCESS,
  FETCH_PROMOS_FAILED,
  EDIT_PROMOS,
  FILTER_PROMOS_BY_CATEGORY,
  FILTER_PROMOS_BY_PAYMENT_METHOD,
  FILTER_PROMOS_BY_BOOKING_TYPE
} from "../store/types";

const INITIAL_STATE = {
  promos: null,
  filteredPromos: null,
  selectedCategory: null,
  selectedPaymentMethod: null,
  selectedBookingType: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const promoreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PROMOS:
      return {
        ...state,
        loading: true
      };
    case FETCH_PROMOS_SUCCESS:
      return {
        ...state,
        promos: action.payload,
        loading: false
      };
    case FETCH_PROMOS_FAILED:
      return {
        ...state,
        promos: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case FILTER_PROMOS_BY_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload,
        filteredPromos: filterPromosByCategoryServiceAndPayment(state.promos, action.payload, null, state.selectedPaymentMethod, state.selectedBookingType)
      };
    case FILTER_PROMOS_BY_PAYMENT_METHOD:
      return {
        ...state,
        selectedPaymentMethod: action.payload,
        filteredPromos: filterPromosByCategoryServiceAndPayment(state.promos, state.selectedCategory, null, action.payload, state.selectedBookingType)
      };
    case FILTER_PROMOS_BY_BOOKING_TYPE:
      return {
        ...state,
        selectedBookingType: action.payload,
        filteredPromos: filterPromosByCategoryServiceAndPayment(state.promos, state.selectedCategory, null, state.selectedPaymentMethod, action.payload)
      };
    case EDIT_PROMOS:
      return state;
    default:
      return state;
  }
};

// Helper function untuk filter promo
const filterPromosByCategoryServiceAndPayment = (promos, category, service, paymentMethod, bookingType) => {
  if (!promos) return null;
  
  return promos.filter(promo => {
    // Check if promo is active and not expired
    const now = new Date().getTime();
    const isValid = promo.promo_validity && now <= promo.promo_validity;
    
    if (!isValid) return false;
    
    // Check category specific promo
    if (promo.category_specific && promo.categories && category) {
      if (!promo.categories.includes(category)) return false;
    }
    
    // Check service specific promo
    if (promo.service_specific && promo.services && service) {
      if (!promo.services.includes(service)) return false;
    }
    
    // Check payment method specific promo
    if (promo.payment_method_specific && promo.payment_methods && paymentMethod) {
      if (!promo.payment_methods.includes(paymentMethod)) return false;
    }
    
    // Check booking type specific promo
    if (promo.booking_type_specific && promo.booking_types && bookingType) {
      if (!promo.booking_types.includes(bookingType)) return false;
    }
    
    return true;
  });
};